import axios from 'axios';

function getCookie(name) {
  try {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  } catch { return null; }
}

function getFbp() {
  return getCookie('_fbp') || null;
}

function getFbc() {
  const cookie = getCookie('_fbc');
  if (cookie) return cookie;
  try {
    const stored = localStorage.getItem('_fbc');
    if (stored) return stored;
  } catch {}
  try {
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      const fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      try { localStorage.setItem('_fbc', fbc); } catch {}
      document.cookie = '_fbc=' + fbc + ';path=/;max-age=7776000;SameSite=Lax';
      return fbc;
    }
  } catch {}
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.fbc) return user.fbc;
  } catch {}
  return null;
}

export function captureFbclid() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      const fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      localStorage.setItem('_fbc', fbc);
      localStorage.setItem('_fbclid', fbclid);
      document.cookie = '_fbc=' + fbc + ';path=/;max-age=7776000;SameSite=Lax';
    }
  } catch {}
}

function getUserData() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const names = (user.nome || '').trim().split(/\s+/);
  const firstName = names[0] || '';
  const lastName = names.length > 1 ? names[names.length - 1] : firstName;
  const phone = user.telefone || '';
  const externalId = (user.id || user._id || '');
  return { user, firstName, lastName, phone, externalId };
}

function sendToServer(payload) {
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = 'Bearer ' + token;

  axios.post(process.env.REACT_APP_API_URL + '/api/track', payload, {
    headers,
    withCredentials: true,
    timeout: 5000,
  }).catch(() => {});
}

export default function trackEvent(eventName, extra = {}) {
  try {
    const { user, firstName, lastName, phone, externalId } = getUserData();
    const eventId = extra.eventId || eventName + '_' + (externalId || 'anon') + '_' + Date.now();

    if (window.fbq) {
      window.fbq('track', eventName, {
        content_name: extra.contentName,
        value: extra.value,
        currency: extra.currency || 'BRL',
        ...extra.pixelData,
      }, { eventID: eventId });
    }

    const fbp = getFbp();
    const fbc = getFbc();

    const payload = {
      eventName,
      eventId,
      url: window.location.href,
      email: (user.email || '').toLowerCase().trim(),
      phone,
      firstName,
      lastName,
      externalId: externalId.toString(),
      fbp,
      fbc,
      country: 'br',
      contentName: extra.contentName,
      value: extra.value,
      currency: extra.currency || 'BRL',
    };

    sendToServer(payload);

    if (!fbp || !fbc) {
      setTimeout(() => {
        const delayedFbp = getFbp();
        const delayedFbc = getFbc();
        if ((delayedFbp && !fbp) || (delayedFbc && !fbc)) {
          sendToServer({ ...payload, fbp: delayedFbp || fbp, fbc: delayedFbc || fbc, eventId: eventId + '_r' });
        }
      }, 2500);
    }
  } catch {}
}

let lastPageViewPath = '';
export function trackPageView() {
  try {
    const path = window.location.pathname;
    if (path === lastPageViewPath) return;
    lastPageViewPath = path;

    captureFbclid();

    const { user, firstName, lastName, phone, externalId } = getUserData();
    if (!user.email) return;

    const fbp = getFbp();
    const fbc = getFbc();
    const eventId = 'PageView_' + (externalId || 'anon') + '_' + Date.now();

    sendToServer({
      eventName: 'PageView',
      eventId,
      url: window.location.href,
      email: (user.email || '').toLowerCase().trim(),
      phone,
      firstName,
      lastName,
      externalId: externalId.toString(),
      fbp,
      fbc,
      country: 'br',
    });

    if (!fbp || !fbc) {
      setTimeout(() => {
        const delayedFbp = getFbp();
        const delayedFbc = getFbc();
        if ((delayedFbp && !fbp) || (delayedFbc && !fbc)) {
          sendToServer({
            eventName: 'PageView',
            eventId: eventId + '_r',
            url: window.location.href,
            email: (user.email || '').toLowerCase().trim(),
            phone, firstName, lastName,
            externalId: externalId.toString(),
            fbp: delayedFbp || fbp,
            fbc: delayedFbc || fbc,
            country: 'br',
          });
        }
      }, 2500);
    }
  } catch {}
}
